import { AccountTier } from '../enums/AccountTier'
import { SboCurrency } from './SboCurrency'

export class UserInfo {
    firstName: string = ''
    lastName: string = ''
    fullName: string = ''
    isInitialDepositDone: boolean = false
    initDepositExpiredDay: number = 0
    isKyc: boolean = false
    accountTier: AccountTier = AccountTier.New
    createdOn: Date = new Date()
    accountId: string = ''
    customerId: number = 0
    katakana: string | null = null
    cpf: string | null = null
    currency: SboCurrency = new SboCurrency()
    isRequiredKyc: boolean = false
    isAllowUsingEwallet: boolean = false
    residentCountryCode: string = ''
    isAllowUsingLocalPayment: boolean = true
    brandName!: string

    constructor(data: PartialProps<UserInfo> = {}) {
        Object.assign(this, data)
    }

    get isNeedToFillInKatakana(): boolean {
        return this.katakana === null
    }
}
